"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountIcon = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AccountIcon = function AccountIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.default, _extends({}, props, {
    viewBox: "0 0 21 20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "10",
    r: "9.2",
    stroke: "currentColor",
    strokeWidth: "1.6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "7",
    r: "2.2",
    stroke: "currentColor",
    strokeWidth: "1.6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 19.2C7.67437 19.2 5.14649 17.927 3.45774 15.9205C4.12456 13.6885 6.89016 11.8 10.4999 11.8C14.1096 11.8 16.8752 13.6885 17.5421 15.9205C15.8533 17.927 13.3254 19.2 10.4999 19.2Z",
    stroke: "currentColor",
    strokeWidth: "1.6",
    fill: "none"
  }));
};
exports.AccountIcon = AccountIcon;